import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective } from 'mbs-ui-kit';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-ip-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchIPTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchIPTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;

  public tag = SmartSearchTemplateName.IP;
  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();

    this.i18nPipe = i18nPipe;
  }
}
